import {IPagination} from '@entities/api/api.interfaces';

export const API_ERROR_KEY = 'apiError';
export const EMPTY_PAGINATOR: IPagination = {
  currentPage: 0,
  perPage: 0,
  totalPages: 0,
  total: 0,
};
